<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>
<!-- shopy Head -->
<div
  class="shopyheader"
  style="background-image: url(assets/image/Group-1893.jpg)"
>
  <div class="shopyheadings">
    <div class="head">
      <h3>ONLINE SHOP</h3>
    </div>
  </div>
</div>



<div class="container " style="margin-top: 2rem;">
  <form #formshop="ngForm" >

    <div class="row">
      <ng-template ngFor let-item [ngForOf]="data" let-i="index" >
        <div class="col-md-4">
            <img style="width: 100%;" src="{{item.shop_image}}" class="prd-image">

        </div>
        <div class="col-md-8">
            <h2>{{data[0]?.shop_head}}</h2>
            <input type="hidden" name="shophead" [ngModel]="data[0]?.shop_head" >
            <div [innerHTML]="eventdetails"></div>
      
            <div class="" *ngIf="getuserinfo; else elseBlock">
              
                <select class="form-select form-control " aria-label="" name="shop_rate" [ngModel]>
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>SELECT LOCATION</option>
                    <option value="{{item.shopmember_usPrice}} USA">USA ${{item.shopmember_usPrice}} USD</option>
                    <option value="{{item.shopmember_canadaPrice}} Canada & Mexico">Canada & Mexico ${{item.shopmember_canadaPrice}} USD</option>
                    <option value="{{item.shopmember_other}} Rest of the World">Rest of the World ${{item.shopmember_other}} USD</option>
                  </select>
            </div>
            <ng-template #elseBlock>
              
              <select class="form-select form-control " aria-label="" name="shop_rate" [ngModel]>
                <option [ngValue]="null" [disabled]="true" [selected]='true'>SELECT LOCATION</option>
                  <option value="{{item.shop_usPrice}} USA">USA ${{item.shop_usPrice}} USD</option>
                  <option value="{{item.shop_canadaPrice}} Canada & Mexico">Canada & Mexico ${{item.shop_canadaPrice}} USD</option>
                  <option value="{{item.shop_other}} Rest of the World">Rest of the World ${{item.shop_other}} USD</option>
                </select>
              </ng-template>
            <a (click)="getitems(formshop.value)" class="btn-shop">
                Buy Now
              </a>


        </div>
      </ng-template>
    </div>
  </form>

</div>